











































































































































































































































































































import { Component } from "vue-property-decorator";
import Vue from "vue";
import { asusDeviceModule } from "@/store/modules/asusDevice";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { asusDownloadoptions, deviceIdsType } from "@/types/asusdevice";
import { masking, has_value } from '@/utils/app-util'

Vue.filter("formatDate", function (value) {
  // 
  return new Date(value * 1000).toLocaleString().substr(0,10);
});

Vue.filter("masking", function (value,masktype) {
  return masking(value,masktype);
});

@Component
export default class AsusDeviceList extends Vue {
  public search = "";
  public btnenable = false;
  public editItem = {
    device_id:null,
    device_name:"",
    iid:"",
    start_time:null,
    end_time:null
  }
  public addnewItem = {
    device_id:null,
    device_name:""
  }
  public addnewDialog = false;
  public editDialog = false;
  public startmenu = false;
  public endmenu = false;
  public editstartmenu = false;
  public editendmenu = false;
  public downloadpayload: asusDownloadoptions = {
      device_ids:[],
      start:null,
      end:null
  }
  public start = new Date().toISOString().split('T')[0];
  public end = new Date().toISOString().split('T')[0];
//   public selected:deviceIdsType[] = [];
  public headers = [
    {
      text: "手錶編號",
      left: true,
      value: "device_id"
    },
    {text: "手錶名稱", value: "device_name"},
    {text: "使用者名稱", value: "user.name"},
    {text: "使用者身分證", value: "user.iid"},
    {text: "使用者穿戴起始時間", value: "start_time"},
    {text: "使用者穿戴結束時間", value: "end_time"},
    {text: "修改", sortable:false, value:"action"}
  ];
  get totalDevices() {
    return asusDeviceModule.totaldevices;
  }

  get user() {
    return userModule.user;
  }

  get loading() {
    return asusDeviceModule.loading;
  }

  get devicelist() {
    return asusDeviceModule.devicelist;
  }

  get downloaddata() {
      return asusDeviceModule.downloaddata;
  }

  async created() {
    this.btnenable = this.user.roles.includes("Owner")||this.user.roles.includes("Admin");
    await asusDeviceModule.getDeviceList();
  }

  async download(){
    const starttimestamp = (Date.parse(this.start) / 1000) - 28800;
    const endtimestamp = (Date.parse(this.end) / 1000) - 28800 + 86399;
    this.downloadpayload.start = starttimestamp;
    this.downloadpayload.end = endtimestamp;
    // console.log(this.selected);
    // console.log(starttimestamp);
    // console.log(endtimestamp);
    if(starttimestamp >= endtimestamp){
        appModule.sendErrorNotice("結束時間必須在起始時間之後");
    }else if(this.downloadpayload.device_ids.length===0){
        appModule.sendErrorNotice("請選取至少一個device");
    }else{
        await asusDeviceModule.getDownloaddata(this.downloadpayload);
        // console.log(this.downloaddata);
        if(typeof this.downloaddata === 'undefined' || this.downloaddata.length === 0){
            appModule.sendErrorNotice("無資料可下載");
        }else{
            return this.downloaddata;
        }
    }
  }

  edit(item){
    this.editItem.device_id = item.device_id;
    this.editItem.device_name = item.device_name;
    if(item.start_time!==null) this.editItem.start_time = new Date(item.start_time * 1000).toISOString().substr(0,10);
    if(item.end_time!==null) this.editItem.end_time = new Date(item.end_time * 1000).toISOString().substr(0,10);
    if(item.user!==null) this.editItem.iid = item.user.iid;
    this.editDialog = true;
  }
  addnewdevice(){
    this.addnewDialog = true;
  }
  saveEdit(){
    if(has_value(this.editItem.start_time)) this.editItem.start_time = (Date.parse(this.editItem.start_time) / 1000) - 28800;
    if(has_value(this.editItem.end_time)) this.editItem.end_time = (Date.parse(this.editItem.end_time) / 1000) - 28800 + 86399;
    if (confirm("確定要更改嗎?") == true) {
      asusDeviceModule.modifyDevice(this.editItem);
    } else {
      appModule.sendErrorNotice("取消更改");
    }
    this.closeEdit()
  }
  closeEdit(){
    this.editItem = {
      device_id:null,
      device_name:"",
      iid:"",
      start_time:null,
      end_time:null
    }
    this.editDialog = false;
  }
  saveAdd(){
    if(!has_value(this.addnewItem.device_id)){
      appModule.sendErrorNotice("`device_id`必填");
    }
    else{
      if (confirm("確定要新增嗎?") == true) {
        asusDeviceModule.addNewDevice(this.addnewItem);
      } else {
        appModule.sendErrorNotice("取消新增");
      }
    }
    this.closeAdd()
  }
  closeAdd(){
    this.addnewItem = {
      device_id:null,
      device_name:""
    }
    this.addnewDialog = false;
  }
}
